import { render } from "./QuizStep.vue?vue&type=template&id=2b2b1066"
import script from "./QuizStep.vue?vue&type=script&lang=js"
export * from "./QuizStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__